<template>
  <footer id="footer">
      <h1 class="SiteFooter">
        <a href="https://pblnz.sharepoint.com/Prof/Vaccination%20Service/Forms/AllItems.aspx?RootFolder=%2FProf%2FVaccination%20Service%2FFlu%20Vaccinations%2FFlu%20Vaccinations%20%26%20Vouchers%202021&FolderCTID=0x012000031B6D81024F8443993967F944316591&View=%7BF816566C%2DBAFA%2D47B3%2D8495%2D2711EFA69908%7D" 
        target="blank" >
        For all the relevant information you need to know for Flu Vaccinations.
        </a>
      </h1>
  </footer>
</template>

<script>
export default {
  name: "RwvFooter"
};
</script>
